import { CodeBlock as CodeBlockToExtend } from '@tiptap/extension-code-block';

export const CodeBlock = CodeBlockToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: null
            },
            style: null
        }
    }
})
